import { createContext, type Dispatch } from 'react';

import type { DispatchAction } from './actions';

import { initialState, type GlobalState } from './initialState';

export const globalStateContext = createContext<GlobalState>(initialState);

export const globalReducer = createContext<Dispatch<DispatchAction>>(() => {});
